/* eslint-disable */
import { $axios } from "../../config/axios";
import PondMother from "../../model/pondmother";
import { cloneDeep, findIndex } from "lodash";
import bkPermissions from "@/constants/bkPermissions";

const state = {
  pondMothers: [],
  mapPmidPm: null,
};
const getters = {
  getPondMothers: (state) => {
    return state.pondMothers.map((pm) => {
      return cloneDeep(pm);
    });
  },
  getObjPmIdPm: (state, getters) => {
    let objPmIdPm = {};
    getters.getPondMothers.forEach((pm) => {
      objPmIdPm[pm._id] = pm;
    });
    return objPmIdPm;
  },
  getPmIdPm: (state) => state.mapPmidPm,
  getMapPmIdMode: (state) => {
    let mapPmIdMode = {};
    let pms = state.pondMothers;
    for (let pm = 0; pm < pms.length; pm++) {
      const pmObj = pms[pm];
      mapPmIdMode[pmObj._id] = pmObj.mode;
    }
    return mapPmIdMode;
  },
  getPmsInAutomaticMode: (state, getters) => {
    return getters["getPondMothers"].filter((pm) => {
      return pm.managed_by === "SHRIMP_TALK";
    });
  },
  getPmsInAutomaticModeGroupByPond: (state, getters) => {
    const pondGPmAuto = {};
    getters["getPmsInAutomaticMode"].forEach((pm) => {
      if (typeof pondGPmAuto[pm.pond_id] === "undefined") {
        pondGPmAuto[pm.pond_id] = [];
      }
      pondGPmAuto[pm.pond_id].push(pm);
    });
    return pondGPmAuto;
  },
  getPmsInBasicMode: (state, getters) => {
    return getters["getPondMothers"].filter((pm) => {
      return pm.managed_by === "MANUAL";
    });
  },
  getPmsInScheduleMode: (state, getters) => {
    return (pms) => {
      return pms.filter((pm) => {
        return pm.managed_by === "FARMER";
      });
    };
  },
};
const mutations = {
  SET_POND_MOTHER_DATA(state, pondMotherData) {
    if (pondMotherData != null) {
      let pmArr = [];
      pondMotherData.forEach((pondmother) => {
        let pmObj = new PondMother();
        pmObj.castToPMObj(pondmother);
        pmArr.push(pmObj);
      });
      state.pondMothers = pmArr;
    } else {
      state.pondMothers = null;
    }
  },
  SET_MAP_PMID_PM(state) {
    let mapPmidPm = new Map();
    if (state.pondMothers != null) {
      state.pondMothers.forEach((pondmother) => {
        mapPmidPm.set(pondmother.pond_mother_id, pondmother);
      });
      state.mapPmidPm = mapPmidPm;
    } else {
      state.mapPmidPm = null;
    }
  },
  PUSH_UPDATED_POND(state, pmData) {
    let pmObj = new Pond();
    pmObj.castToPondObj(pmData);
    let index = findIndex(state.pondMothers, function(pondmother) {
      return pondmother.pond_mother_id === pmData.pond_mother_id;
    });
    state.pondMothers[index] = pmObj;
    if (state.mapPmidPm.get(pmObj.pond_mother_id)) {
      state.mapPmidPm.set(pmObj.pond_mother_id, pmObj);
    }
  },
};
const actions = {
  fetchAllPondMothers: function(context, queryParams) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/pond-mothers", {
          params: queryParams,
        })
        .then((response) => {
          context.commit("SET_POND_MOTHER_DATA", response.data.pond_mothers);
          context.commit("SET_MAP_PMID_PM");
          resolve({
            message: response.data.message,
            totalPMs: response.data.total,
            page: response.data.page,
          });
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchAPondMother: function(context, pondMotherId) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/pond-mothers/" + pondMotherId)
        .then((response) => {
          //context.commit('SET_POND_MOTHER_DATA',response.data.pondMothers)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPondMothersOnPondId: async function(context, pondId) {
    const requiredPermissions = bkPermissions["/ponds/:pond_id/pond-mothers"];
    const canAccessApi = context.rootGetters[
      "user/canUserAccessApiByBkPermissions"
    ](requiredPermissions);
    if (!canAccessApi) {
      console.error("No Permissions to call this api");
      return [];
    }
    try {
      const response = await $axios.get(`/ponds/${pondId}/pond-mothers`, {
        include: ["title", "code"],
      });
      return response.data.pond_mothers;
    } catch (err) {
      throw err;
      console.error(err);
    }
  },
  addPondMotherDetails: function(context, pondMothers) {
    return new Promise((resolve, reject) => {
      $axios
        .post("/ponds/pond-mothers", pondMothers)
        .then((response) => {
          //  context.commit('SET_POND_MOTHER_DATA',response.data.pondMothers)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  updatePMSettings: function(context, pondMothers) {
    return new Promise((resolve, reject) => {
      $axios
        .patch("/ponds/pond-mothers/settings", pondMothers)
        .then((response) => {
          //context.commit('SET_POND_MOTHER_DATA',response.data.pondMothers)
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  unAssignPondMothers: function(context, pondMother) {
    return new Promise((resolve, reject) => {
      $axios
        .delete(`/ponds/pond-mothers/${pondMother}`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchSlotWisePMFeed: function(context, { pondmother, params }) {
    return new Promise((resolve, reject) => {
      $axios
        .get("/ponds/pond-mothers/" + pondmother + "/slotwise-feed", { params })
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
